//src/index.js
import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux'; // 引入 Redux Provider
import { HashRouter } from 'react-router-dom'; // 修改为 HashRouter
import store from './store'; // 引入 Redux store
import './styles/global.css';
import App from './App';
import './i18n'; // 导入i18n配置

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <Provider store={store}> {/* 将 Redux store 注入应用 */}
    <HashRouter> {/* 修改为 HashRouter */}
      <App />
    </HashRouter>
  </Provider>
);